import React, { useEffect, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { noop, map } from 'underscore';
import { componentsConfig } from '@bingads-webui-campaign-react/smart-component-util';

import { buildNestedTree } from './util/build-tree';
import { runtimeComponentsMapping } from './loader/runtime-smart-components-loader';
import { FluentGridLayout } from './layout/fluent-grid-layout';
import { DynamicComponentRender } from './dynamic-component-render';

// currently we only have one
const searchLayout = () => FluentGridLayout;
const PageLayout = searchLayout();

const emptyWSD = {};

export const SiteBuilderInternal = ({
  pages,
  websiteSourceData,
  onRenderCompleted,
  componentsMapping,
  className,
  enabledComponentsConfig,
}) => {
  const orderedComponentsInPages = useRef([]);

  useEffect(() => {
    // when pages change, we should pass new orderedComponentsInPages out
    onRenderCompleted({
      orderedComponentsInPages: orderedComponentsInPages.current,
    });
  }, [onRenderCompleted, pages, websiteSourceData]);

  const components = useMemo(() => {
    orderedComponentsInPages.current = [];

    return map(pages, (page, index) => {
      const tree = buildNestedTree(page, enabledComponentsConfig);
      tree.type = 'page';

      return (
        <PageLayout
          key={page.id}
          page={tree}
          dynamicComponentRender={(componentConfig) => {
            const newComponentsInPage = [...(orderedComponentsInPages.current[index] || [])];
            newComponentsInPage.push({
              type: componentConfig.type,
              id: componentConfig.id,
            });
            orderedComponentsInPages.current[index] = newComponentsInPage;

            return (
              <DynamicComponentRender
                componentsMapping={componentsMapping}
                config={componentConfig}
              />
            );
          }}
        />
      );
    });
  }, [pages, enabledComponentsConfig, componentsMapping]);

  return (
    <div className={className}>
      {components}
    </div>
  );
};

SiteBuilderInternal.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.any).isRequired,
  websiteSourceData: PropTypes.shape({}),
  componentsMapping: PropTypes.objectOf(PropTypes.elementType),
  onRenderCompleted: PropTypes.func,
  className: PropTypes.string,
  enabledComponentsConfig: PropTypes.objectOf(PropTypes.object),
};

SiteBuilderInternal.defaultProps = {
  websiteSourceData: emptyWSD,
  onRenderCompleted: noop,
  componentsMapping: runtimeComponentsMapping,
  className: '',
  enabledComponentsConfig: componentsConfig,
};
